import { core_apimessages_Money as Money } from '../schemas/rql';
import { Location } from 'history';
import RouterHistory from '@reverbdotcom/commons/src/cms/lib/router_history';
import { Paths } from '../components/shared/url_helpers';

export function buildCheckoutPaths(checkoutId: string, location: Location = RouterHistory.getCurrentLocation()) {
  const { _reverb_app } = location.query;

  function show({ showCheckoutError }: { showCheckoutError?: boolean } = {}) {
    return Paths.checkoutShow.expand({
      checkoutId,
      _reverb_app,
      show_checkout_error: showCheckoutError,
    });
  }

  function paymentInProgress() {
    return Paths.checkoutPaymentInProgress.expand({ checkoutId, _reverb_app });
  }

  function redirectReturn({ displayedAmountOwed }: { displayedAmountOwed: Pick<Money, 'amountCents' | 'currency'> }) {
    return Paths.checkoutRedirectReturn.expand({
      checkoutId,
      _reverb_app,
      displayed_amount_owed_cents: displayedAmountOwed.amountCents,
      displayed_amount_owed_currency: displayedAmountOwed.currency,
    });
  }

  return {
    show,
    redirectReturn,
    paymentInProgress,
  };
}
